// SH:NOTE: Make sure Application is the first export, as this ensures PIXI is imported first as well
// SH:TODO: Are there clearer alternatives to the above note?
export * from "./Application";

import * as Input from "./Input";
import { LogUtils } from "./Utils";
import * as BuildInfo from "./version";

export { Input };

export * from "./Audio";
export * from "./Copy";
export * from "./Data";
export * from "./Filters";
export * from "./GameObjects";
export * from "./Load";
export * from "./Popup";
export * from "./State";
export * from "./Utils";
export * from "./version";

let hello: string = `%c${BuildInfo.PACKAGE_NAME} v${BuildInfo.PACKAGE_VERSION}`;
if (BuildInfo.GIT_BRANCH !== undefined) {
    hello += ` - ${BuildInfo.GIT_BRANCH}`;
    if (BuildInfo.GIT_COMMIT !== undefined) {
        hello += `#${BuildInfo.GIT_COMMIT.substr(0, 7)}`;
    }
}
hello += " - %chttps://reli.sh";
console.log(hello, LogUtils.STYLE_BLACK, LogUtils.STYLE_RELISH_BOLD);
